import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { formatDate } from "../../utils/formatDate";
import { PageLoader } from "../Loader/loader";

const money = (amount, currency) =>
  amount === null || amount === undefined
    ? "—"
    : `${new Intl.NumberFormat("ru-RU").format(amount)} ${currency || "AMD"}`;

// "My payments": the member's annual-fee transactions and the date the membership is valid until.
const Payments = () => {
  const { user, fetchPayments } = useAuth();
  const [payments, setPayments] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchPayments()
      .then((data) => !cancelled && setPayments(data))
      .catch(() => !cancelled && setError(true));
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div className="account-panel">
        <h2 className="account-title">Վճարումներ</h2>
        <div className="auth-alert">Չհաջողվեց բեռնել վճարումները։ Փորձեք կրկին։</div>
      </div>
    );
  }

  if (!payments) return <PageLoader compact />;

  const membership = user.membership || { status: "none" };
  const summary =
    membership.status === "active"
      ? { cls: "active", text: `Անդամավճարը գործում է մինչև ${formatDate(membership.valid_until)}` }
      : membership.status === "expired"
      ? { cls: "expired", text: `Անդամավճարը ժամկետանց է (${formatDate(membership.valid_until)})` }
      : { cls: "none", text: "Անդամավճարը դեռ չի վճարվել" };

  return (
    <div className="account-panel">
      <h2 className="account-title">Վճարումներ</h2>
      <div className={`pay-summary ${summary.cls}`}>{summary.text}</div>

      {payments.length === 0 ? (
        <p className="auth-muted">Վճարումներ դեռ չկան։</p>
      ) : (
        <ul className="pay-list">
          {payments.map((p) => (
            <li key={p.id} className="pay-item">
              <div className="pay-year">
                {p.year}
                <span className={`pay-badge ${p.active ? "active" : "expired"}`}>
                  {p.active ? "Գործում է" : "Ժամկետանց"}
                </span>
              </div>
              <dl className="pay-rows">
                <div>
                  <dt>Վճարման ամսաթիվ</dt>
                  <dd>{formatDate(p.paid_at)}</dd>
                </div>
                <div>
                  <dt>Գումար</dt>
                  <dd>{money(p.amount, p.currency)}</dd>
                </div>
                {p.transaction_id && (
                  <div>
                    <dt>Գործարքի համար</dt>
                    <dd>{p.transaction_id}</dd>
                  </div>
                )}
              </dl>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Payments;
